import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery';

import type {
	ExcludeNewConfluenceActiveUserQuery as ExcludeNewConfluenceActiveUserQueryData,
	ExcludeNewConfluenceActiveUserQueryVariables,
	ExcludeNewConfluenceActiveUserQuery_experimentalSiteUserPersonalization_ExperimentalSiteUserPersonalization as ExcludeNewConfluenceActiveUserQueryResponse,
} from './__types__/ExcludeNewConfluenceActiveUserQuery';

export type UseExperimentalSiteUserPersonalizationParams = {
	variables: ExcludeNewConfluenceActiveUserQueryVariables;
	skip?: boolean;
};

export const useExperimentalSiteUserPersonalization = ({
	variables,
	skip,
}: UseExperimentalSiteUserPersonalizationParams) => {
	return useExperimentalQuery<
		ExcludeNewConfluenceActiveUserQueryData,
		ExcludeNewConfluenceActiveUserQueryVariables,
		ExcludeNewConfluenceActiveUserQueryResponse
	>({
		url: ({ cloudId, userId }) =>
			`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
		method: 'GET',
		variables,
		parseResult: (json): ExcludeNewConfluenceActiveUserQueryData => ({
			experimentalSiteUserPersonalization: json,
		}),
		skip,
	});
};
